const GOOGLE_MAPS_JS_API_KEY = 'AIzaSyC4Tl7IMVdoOkGL79Q_xf8WCK9ofKUa2lg';

export { GOOGLE_MAPS_JS_API_KEY };